import { setPresetLayout, deleteActiveLayoutNode } from './actions';
export const FLOATING_TOOLBAR_ITEMS = [{
  id: 'two_equal',
  icon: 'tap-icon-editor-two-equal',
  title: 'Two columns',
  onClick: setPresetLayout('two_equal')
}, {
  id: 'two_left_sidebar',
  icon: 'tap-icon-editor-two-leftside-bar',
  title: 'Left sidebar',
  onClick: setPresetLayout('two_left_sidebar')
}, {
  id: 'two_right_sidebar',
  icon: 'tap-icon-editor-two-rightside-bar',
  title: 'Right sidebar',
  onClick: setPresetLayout('two_right_sidebar')
}, {
  id: 'three_equal',
  icon: 'tap-icon-editor-two-rightside-bar',
  title: 'Three columns',
  onClick: setPresetLayout('three_equal')
}, {
  id: 'three_with_sidebars',
  icon: 'tap-icon-editor-two-rightside-bar',
  title: 'Three columns with sidebars',
  onClick: setPresetLayout('three_with_sidebars')
}, {
  id: 'separator-remove',
  separator: true
}, {
  id: 'remove',
  icon: 'tap-icon-delete-fill',
  title: 'Remove',
  onClick: deleteActiveLayoutNode
}];